import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import UiUploading from "../../UI/ui-uploading/UiUploading";
import UiText from "../../UI/ui-text/UiText";
import UiPass from "../../UI/ui-text/UiPass";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import { ref, uploadBytes } from "firebase/storage";
import { storage } from "../../Firebase";
import AXIOS from "../../Axios";

const RegisterPage = (propse) => {
  const [Image, setImage] = useState(null);
  const [Name, setName] = useState("sara");
  const [Email, setEmail] = useState("sara@yahoo.com");
  const [Category, setCategory] = useState("english");
  const [Password, setPassword] = useState("123");
  const [Error1, setError1] = useState("");
  const [Error2, setError2] = useState("");
  const [Error3, setError3] = useState("");
  const [Error4, setError4] = useState("");
  const OnChange = (e, event) => {
    if (e === "NAME") {
      setName(event.target.value);
      setError1(false);
    }
    if (e === "EMAIL") {
      setEmail(event.target.value);
      setError2(false);
    }
    if (e === "CATEGORY") {
      setCategory(event.target.value);
      setError3(false);
    }
    if (e === "PASSWORD") {
      setPassword(event.target.value);
      setError4(false);
    }
  };
  const onClick = (e) => {
    if (e === "NAME") {
      setName("");
      setError1(false);
    }
    if (e === "EMAIL") {
      setEmail("");
      setError2(false);
    }
    if (e === "CATEGORY") {
      setCategory("");
      setError3(false);
    }
    if (e === "PASSWORD") {
      setPassword("");
      setError4(false);
    }
    if (e === "BACK") {
      propse.setRegister(false);
      propse.setLogin(false);
    }
  };
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const onSubmit = async (event) => {
    event.preventDefault();
    let formIsValid = true;
    if (Name.trim().length === 0) {
      setError1(true);
      formIsValid = false;
    }
    if (Email.trim().length === 0 || !isValidEmail(Email)) {
      setError2(true);
      formIsValid = false;
    }
    if (Category.trim().length === 0) {
      setError3(true);
      formIsValid = false;
    }
    if (Password.trim().length === 0) {
      setError4(true);
      formIsValid = false;
    }
    if (formIsValid) {
      propse.setLoading(true);
      let EMAILS = [];
      const DATA = {
        NAME: Name.trim(),
        EMAIL: Email.trim(),
        CATEGORY: Category.trim(),
        PASSWORD: Password.trim(),
      };
      propse.setEmailRepeat(Email);
      await AXIOS.get("/LB.json")
        .then((response) => {
          if (response.status === 200) {
            if (response.data === null) {
              AXIOS.post(`/LB/REGISTER.json`, JSON.stringify(DATA))
                .then((RES) => {
                  propse.setLoading(false);
                  propse.setRegister(false);
                  propse.setLogin(true);
                })
                .catch((error) => {
                  console.error(error);
                });
            } else {
              const myArray = Object.entries(response.data.REGISTER);
              for (let x in myArray) {
                let index = EMAILS.indexOf(myArray[x][1].EMAIL);
                if (index === -1) EMAILS.push(myArray[x][1].EMAIL);
              }
              let index = EMAILS.indexOf(Email.trim().toLowerCase());
              if (index === -1) {
                AXIOS.post(`/LB/REGISTER.json`, JSON.stringify(DATA))
                  .then((RES) => {
                    if (Image !== null) {
                      const ImageRef = ref(storage, `images/${Email}`);
                      uploadBytes(ImageRef, Image)
                        .then((response) => {
                          propse.setLoading(false);
                          propse.setRegister(false);
                          propse.setLogin(true);
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    }
                  })
                  .catch((error) => {
                    console.error(error);
                  });
              } else {
                propse.setShowModal({
                  SHOW: true,
                  PM1: "This",
                  PM2: Email,
                  PM3: "is available in the database!",
                });
              }
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  return (
    <React.Fragment>
      <Box sx={{ width: propse.Width < 560 ? "100%" : "90%" }}>
        {propse.Width >= 560 ? (
          <Box>
            <Box
              sx={{
                width: "38px",
                height: "38px",
                backgroundColor: "rgba(90,90,90,0.1)",
                borderRadius: "50%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                color: "rgba(70,70,70)",
              }}
            >
              <CloudQueueIcon />
            </Box>
            <Box
              sx={{
                marginTop: "-30px",
                marginLeft: "48px",
                fontSize: "1.2rem",
                color: "#000",
              }}
            >
              register
            </Box>
          </Box>
        ) : null}
        <form onSubmit={onSubmit}>
          <Box sx={{ marginTop: "20px" }}>
            <UiUploading setImage={setImage} HTMLFor={propse.HTMLFor} />
          </Box>
          <Box
            sx={{
              width:
                propse.Width < 560 ||
                (propse.Width >= 560 && propse.Width < 768)
                  ? "100%"
                  : "70%",
            }}
          >
            <UiText
              ID="N-R"
              Value={Name}
              Lable="Name"
              Error={Error1}
              OnChange={(e) => OnChange("NAME", e)}
              onClick={() => onClick("NAME")}
            />
            <UiText
              ID="EMAIL"
              Value={Email}
              Lable="Email"
              Error={Error2}
              OnChange={(e) => OnChange("EMAIL", e)}
              onClick={() => onClick("EMAIL")}
            />
            <UiText
              ID="CATEGORY"
              Value={Category}
              Lable="Category"
              Error={Error3}
              OnChange={(e) => OnChange("CATEGORY", e)}
              onClick={() => onClick("CATEGORY")}
            />
            <UiPass
              ID="PASSWORD"
              Value={Password}
              Lable="Password"
              Error={Error4}
              OnChange={(e) => OnChange("PASSWORD", e)}
            />
            {propse.Loading ? (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#ed013e",
                  width: propse.Width < 560 ? "100%" : "150px",
                  height: "45px",
                  fontFamily: "Poppins",
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                  zIndex: "6",
                  marginTop:
                    propse.Width < 560 ? "calc(100vh - 462px)" : "20px",
                  display: "flex",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#ed013e")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#ed013e")
                }
              >
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ marginRight: "7px" }}
                ></i>
                Loading
              </Button>
            ) : (
              <Button
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#ed013e",
                  width: propse.Width < 560 ? "100%" : "150px",
                  height: "45px",
                  fontFamily: "Poppins",
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                  zIndex: "6",
                  marginTop:
                    propse.Width < 560 ? "calc(100vh - 462px)" : "20px",
                  display: "flex",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#ed013e")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#ed013e")
                }
              >
                REGISTER
              </Button>
            )}

            <Box
              sx={{
                width:
                  propse.Width >= 560 && propse.Width < 768 ? "100px" : "150px",
                height: "45px",
                display: propse.Width < 560 ? "none" : "flex",
                flexDirection: "row",
                justifyContent: "center",
                textAlign: "center",
                alignItems: "center",
                marginTop: "-40px",
                marginLeft: "130px",
                color: "rgba(70,70,70)",
              }}
            >
              <Box sx={{ cursor: "pointer" }} onClick={() => onClick("BACK")}>
                <KeyboardBackspaceRoundedIcon />
                <RemoveRoundedIcon sx={{ marginLeft: "-4px" }} />
              </Box>
            </Box>
          </Box>
        </form>
      </Box>
    </React.Fragment>
  );
};

export default RegisterPage;
